import { CircleAlert, CircleCheck, Info, LoaderCircle, TriangleAlert } from 'lucide-react';
import { Toaster as Sonner } from 'sonner';

import { useTheme } from '../lib/theme';

/**
 * Avisos con la piel de la consola: tarjeta con la misma sombra que los menús, ícono de estado en
 * su color (nunca sólo el color) y el tema claro/oscuro que eligió la persona.
 */
export function Toaster() {
  const { resolved } = useTheme();
  return (
    <Sonner
      theme={resolved}
      position="top-right"
      closeButton
      icons={{
        success: <CircleCheck className="size-[1.1rem] text-success" />,
        error: <CircleAlert className="size-[1.1rem] text-destructive" />,
        warning: <TriangleAlert className="size-[1.1rem] text-warning" />,
        info: <Info className="size-[1.1rem] text-highlight" />,
        loading: <LoaderCircle className="size-[1.1rem] animate-spin text-muted-foreground" />,
      }}
      toastOptions={{
        classNames: {
          toast:
            'group !rounded-xl !border !border-border !bg-popover !text-popover-foreground !shadow-popover !font-sans !gap-3 !py-3.5',
          title: '!text-sm !font-medium',
          description: '!text-sm !text-muted-foreground',
          success: '!border-l-4 !border-l-success',
          error: '!border-l-4 !border-l-destructive',
          warning: '!border-l-4 !border-l-warning',
          info: '!border-l-4 !border-l-highlight',
          closeButton: '!bg-popover !border-border !text-muted-foreground hover:!text-foreground',
        },
      }}
    />
  );
}
